import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import ReactApexChart from "react-apexcharts";

// Chart options
const areaChartOptions = {
    chart: {
        height: 450,
        type: "area",
        toolbar: { show: false },
    },
    dataLabels: { enabled: false },
    stroke: {
        curve: "smooth",
        width: 2,
    },
    grid: { strokeDashArray: 0 },
};

export default function IncomeAreaChart({ slot, data }) {
    const theme = useTheme();
    const { primary,secondary } = theme.palette.text;
    const line = theme.palette.divider;

    const [options, setOptions] = useState(areaChartOptions);
    const [series, setSeries] = useState([]);

    // Function to format the last 12 months dynamically
    const getLast12Months = () => {
        const months = [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];

        const currentDate = new Date();
        const last12Months = [];

        for (let i = 11; i >= 0; i--) {
            const d = new Date(currentDate);
            d.setMonth(d.getMonth() - i);
            last12Months.push(`${months[d.getMonth()]} ${d.getFullYear()}`);
        }

        return last12Months;
    };

    useEffect(() => {
        // Get last 12 months labels
        const last12MonthsLabels = getLast12Months();

        // Define months array here
        const months = [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];

        // Prepare an object to map month-year to revenue
        const revenueMap = {};
        data?.forEach((entry) => {
            const key = `${entry.month}-${entry.year}`;
            revenueMap[key] = entry.revenue;
        });

        // Map data to ensure all months are displayed (even if revenue is missing)
        const formattedRevenue = last12MonthsLabels.map((label) => {
            const [monthStr, year] = label.split(" ");
            const monthIndex = months.indexOf(monthStr) + 1; // Convert month name to number (1-12)
            return revenueMap[`${monthIndex}-${year}`] || 0;
        });

        // Update chart options and series
        setOptions((prevState) => ({
            ...prevState,
            xaxis: {
                categories: last12MonthsLabels,
                labels: { style: { colors: Array(12).fill(secondary) } },
                axisBorder: { show: true, color: line },
                tickAmount: 11,
            },
            yaxis: {

                labels: {
                    style: { colors: [secondary] },
                    formatter: (val) => `CHF ${Math.round(val).toLocaleString('de-CH')}`,
                }

                },
            tooltip: {
                y: {
                    formatter: (val) =>
                        `CHF ${Math.round(val).toLocaleString('de-CH')}`,
                },
            },
            grid: { borderColor: line },

        }));

        setSeries([{ name: "Revenue CHF", data: formattedRevenue }]);
    }, [data, secondary, line, theme]);

    return <ReactApexChart options={options} series={series} type="area" height={290} />;
}

IncomeAreaChart.propTypes = {
    slot: PropTypes.string,
    data: PropTypes.arrayOf(
        PropTypes.shape({
            month: PropTypes.number.isRequired,
            year: PropTypes.number.isRequired,
            revenue: PropTypes.number.isRequired,
        })
    ).isRequired,
};
